import viewport from "./viewport"

export default function () {

    let header = document.getElementsByClassName('header-bottom')[0];
    let headerTop = 0;
    document.body.classList.remove('header-fixed');

    if(header){
        headerTop = header.offsetTop;
    }

    function checkFixed() {
        if(!window.scrollLocked && viewport().width > 765) {
            let windTop = window.scrollY;
            if (windTop > headerTop) {
                document.body.classList.add('header-fixed');

            }
            else {
                document.body.classList.remove('header-fixed');
            }
        }
    }

    window.addEventListener('scroll', function() {
        checkFixed();
    });

    window.addEventListener('resize', function() {
        if(header && !window.scrollLocked){
            document.body.classList.remove('header-fixed');
            headerTop = header.offsetTop;
            checkFixed();
        }
    });

    window.addEventListener('load', function() {
        if(header && !window.scrollLocked){
            document.body.classList.remove('header-fixed');
            headerTop = header.offsetTop;
            checkFixed();
        }
    });

    checkFixed();
}
